import {
  FORM_CONSTANTS,
  FORM_VALIDATORS,
  TYPE_FIELDS
} from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { FormSchema } from "@/shared/models/FormSchema";
import { Component, Prop, Vue } from "vue-property-decorator";
import ModifVJsfInput from "@/shared/components/ModifVJsfInput/ModifVJsfInput.vue";
import {
  ACTION_CARD_EVENT,
  ACTION_EVENT,
  ACTION_MODAL_TEXT,
  ACTION_MODAL_TITLE,
  EDIT_FIELD_ERROR,
  MEDICAL_ORDER_CONSTANTS,
  MEDICAL_ORDER_PROPERTIES,
  MEDICAL_ORDER_PROPERTIES_ARRAY,
  NEW_ACTION_LABEL
} from "../../constants/ActionConstants";
import { MedicalOrderField } from "@/modules/MedicalOrder/models/MedicalOrderField";
import { PhoneSchema } from "@/shared/models/PhoneSchema";
import { FieldOrder } from "@/modules/Orders/models/FieldOrder";
import { ORDER_CONSTANTS } from "@/modules/Orders/constants/OrderConstants";
import { PhonePayload } from "@/modules/InfoGroup/models/PhonePayload";
import { TitleList } from "@/shared/models/TitleList";
import { Schema } from "@/modules/FormTemplate/models/Schema";
import { FORMS_CONSTANTS } from "@/modules/Forms/constants/FormsConstants";
import { ListSchema } from "@/modules/List/models/ListSchema";
import { PhoneModel } from "@/shared/models/PhoneModel";
import { MedicalOrderFieldsMap } from "@/modules/MedicalOrder/models/MedicalOrderFieldsMap";
import { ActionParameters } from "../../models/ActionParameters";
import { ActionId } from "../../models/ActionId";
import { OrderListDataView } from "@/modules/Orders/models/OrderListDataView";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import {
  EMPTY_STATE_HEADER_EDIT_MEDICAL_ORDER,
  EMPTY_STATE_PARAGRAPH_EDIT_MEDICAL_ORDER
} from "../../constants/AdminDashboardConstants";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import Vuetify from "vuetify";
import VuePhoneNumberInput from "vue-phone-number-input";
import { PreventKey } from "@/shared/mixins/mixins";

Vue.use(Vuetify);
@Component({
  name: "MedicalOrderFieldsDialog",
  components: {
    ModifVJsfInput,
    EmptyState,
    ModalTemplate,
    VuePhoneNumberInput
  }
})
export default class MedicalOrderFieldsDialog extends PreventKey {
  @Prop() private dialog!: boolean;
  @Prop() private userIdArray!: ActionId[];
  @Prop() private schema!: FormSchema;
  @Prop() private fieldsOrder!: FieldOrder[];
  @Prop() private listData!: OrderListDataView;
  @Prop() private editableFields!: string[];

  /* eslint-disable  @typescript-eslint/no-explicit-any */
  model: any = {};
  updateKey = 0;
  phoneTypeList: PhoneSchema[] = [];

  billType = "";
  orderState = "";
  diagnosticPrimaryCode = "";
  orderCancelValue = "";
  nroMedicalOrder = "";
  dialogAccept = false;
  showDialog = false;
  newAction: ActionParameters = {} as ActionParameters;

  TITLE = MEDICAL_ORDER_CONSTANTS.TITLE;
  SUB_TITLE = MEDICAL_ORDER_CONSTANTS.SUB_TITLE;
  FIXED_FIELDS = MEDICAL_ORDER_CONSTANTS.FIXED_FIELDS;
  CUSTOM_FIELDS = MEDICAL_ORDER_CONSTANTS.CUSTOM_FIELDS;
  NEW_ACTION_BTN_LABEL = NEW_ACTION_LABEL.NEW_ACTION_BTN_LABEL;
  CANCEL_BTN = FORM_CONSTANTS.BUTTON.CANCEL;
  STATE_LABEL = ORDER_CONSTANTS.LABELS.STATE;
  DIAG_CODE = ORDER_CONSTANTS.LABELS.DIAG_CODE;
  CANCEL_VALUE = ORDER_CONSTANTS.LABELS.CANCEL_VALUE;
  EXTERNAL_NUMBER = ORDER_CONSTANTS.LABELS.EXTERNAL_NUMBER;
  BILL_TYPE = ORDER_CONSTANTS.LABELS.BILL_TYPE;
  CAMPUS = ORDER_CONSTANTS.LABELS.CAMPUS;
  PROPERTIES = MEDICAL_ORDER_PROPERTIES;
  PROPERTIES_ARRAY = MEDICAL_ORDER_PROPERTIES_ARRAY;
  EMPTY_STATE_HEADER = EMPTY_STATE_HEADER_EDIT_MEDICAL_ORDER;
  EMPTY_STATE_PARAGRAPH = EMPTY_STATE_PARAGRAPH_EDIT_MEDICAL_ORDER;
  ACTION_MODAL_TITLE = ACTION_MODAL_TITLE;
  ACTION_MODAL_TEXT = ACTION_MODAL_TEXT;

  cardClass = STYLE_CLASSES.CARD;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  btnClassPrimary = STYLE_CLASSES.PRIMARY_BTN;
  btnClassSecondary = STYLE_CLASSES.SECONDARY_BTN;

  integerDecimalField = FORM_VALIDATORS.INTEGER_AND_DECIMAL_NUMBER_FIELD;

  isEditable(fieldName: string): boolean {
    return this.editableFields
      ? this.editableFields.includes(fieldName)
      : false;
  }

  validateSchemaFields(): boolean {
    return this.schema.allOf[0]
      ? Object.keys(this.schema.allOf[0].properties).length > 0
      : false;
  }

  validateFixedFields(): boolean {
    for (
      let index = 0;
      index < MEDICAL_ORDER_PROPERTIES_ARRAY.length;
      index++
    ) {
      if (
        this.editableFields &&
        this.editableFields.includes(MEDICAL_ORDER_PROPERTIES_ARRAY[index])
      )
        return true;
    }
    return false;
  }

  fillNewAction(): ActionParameters {
    const newAction: ActionParameters = {
      ids: this.userIdArray,
      type: ACTION_EVENT.MEDICAL_ORDER,
      medicalOrder: this.mapChangesToAction()
    };
    return newAction;
  }

  mapChangesToAction(): MedicalOrderFieldsMap {
    const fields: MedicalOrderFieldsMap = {};
    if (this.schema.allOf[0]) {
      const properties: { [name: string]: Schema } = this.schema.allOf[0]
        .properties;
      for (const field in this.model) {
        if (this.model[field]) {
          const fieldModel: MedicalOrderField = {
            title: properties[field].title,
            value: this.model[field]
          };
          switch (properties[field].typeField) {
            case TYPE_FIELDS.LIST:
              this.fillListData(fieldModel, properties, field);
              if (
                fieldModel.titleSelectValue &&
                fieldModel.titleSelectValue.length > 0
              ) {
                fields[field] = fieldModel;
              }
              break;
            case TYPE_FIELDS.PHONE:
              this.fillPhoneFieldData(fieldModel, field);
              fields[field] = fieldModel;
              break;
            default:
              fields[field] = fieldModel;
          }
          this.showDialog = true;
        }
      }
    }
    if (this.billType !== "")
      fields[MEDICAL_ORDER_PROPERTIES.BILL_TYPE] = {
        title: "",
        value: this.billType
      };
    if (this.orderState !== "")
      fields[MEDICAL_ORDER_PROPERTIES.STATE] = {
        title: "",
        value: this.orderState
      };
    if (this.diagnosticPrimaryCode !== "")
      fields[MEDICAL_ORDER_PROPERTIES.DIAG_CODE] = {
        title: "",
        value: this.diagnosticPrimaryCode
      };
    if (this.orderCancelValue !== "")
      fields[MEDICAL_ORDER_PROPERTIES.CANCEL_VALUE] = {
        title: "",
        value: this.orderCancelValue
      };
    if (this.nroMedicalOrder !== "")
      fields[MEDICAL_ORDER_PROPERTIES.NRO_MEDICAL_ORDER] = {
        title: "",
        value: this.nroMedicalOrder
      };
    return fields;
  }

  fillListData(
    fieldModel: MedicalOrderField,
    properties: { [name: string]: Schema },
    field: string
  ) {
    const titleOption: TitleList[] = [];
    let scoreSelectValue = null;
    const display = properties[field]["x-display"];

    switch (display) {
      case FORMS_CONSTANTS.FIELD.RADIO:
      case FORMS_CONSTANTS.FIELD.SELECT: {
        const listOption = properties[field].oneOf?.find(
          item => item.const === this.model[field]
        );
        if (listOption) this.setTitleOption(titleOption, listOption, display);
        scoreSelectValue = listOption?.score;
        break;
      }
      case FORMS_CONSTANTS.FIELD.CHECKBOX: {
        for (const checkItem in this.model[field]) {
          const listOption = properties[field].items?.oneOf?.find(
            item => item.const === this.model[field][checkItem]
          );
          if (listOption)
            this.setTitleOption(
              titleOption,
              listOption,
              FORMS_CONSTANTS.FIELD.CHECKBOX
            );
        }
        scoreSelectValue = null;
        break;
      }
    }

    fieldModel.listTemplate = properties[field].listTemplate;
    fieldModel.titleSelectValue = titleOption;
    fieldModel.scoreSelectValue = scoreSelectValue;
  }

  fillPhoneFieldData(fieldModel: MedicalOrderField, field: string) {
    const indexPhone = this.phoneTypeList.findIndex(
      p => p.slot === `custom-${field}`
    );

    const phoneModel: PhoneModel = {
      countryCode: this.phoneTypeList[indexPhone].model
        ? this.phoneTypeList[indexPhone].countryCode
        : "",
      countryCallingCode: this.phoneTypeList[indexPhone].model
        ? this.phoneTypeList[indexPhone].countryCallingCode
        : "",
      model: this.phoneTypeList[indexPhone].model
    };

    fieldModel.value = this.phoneTypeList[indexPhone].formattedNumber;
    fieldModel.phoneModel = phoneModel;
  }

  setTitleOption(
    titleOption: TitleList[],
    listOption: ListSchema,
    type: string
  ) {
    titleOption.push({
      title: listOption ? listOption.title : "",
      value: listOption ? listOption.const : "",
      type
    });
  }

  onUpdate(payload: PhonePayload, index: number) {
    this.phoneTypeList[index].countryCode = payload.countryCode;
    this.phoneTypeList[index].countryCallingCode = payload.countryCallingCode;
    this.phoneTypeList[index].formattedNumber = payload.formattedNumber || "";
    this.phoneTypeList[index].isValid = payload.isValid;
  }

  sendDataAction() {
    this.newAction = this.fillNewAction();

    if (
      this.newAction.medicalOrder &&
      Object.keys(this.newAction.medicalOrder).length > 0
    ) {
      if (this.showDialog) {
        this.dialogAccept = true;
      } else {
        this.$emit(ACTION_CARD_EVENT.SEND_DATA_ACTION, this.newAction);
        this.clearData();
      }
    } else {
      Snackbar.popError(EDIT_FIELD_ERROR);
    }
  }

  handleModalAccept() {
    this.$emit(ACTION_CARD_EVENT.SEND_DATA_ACTION, this.newAction);
    this.clearData();
  }

  handleModalCancel() {
    this.dialogAccept = false;
  }

  cancelAction() {
    this.model = {};
    this.updateKey = 1 - this.updateKey;
    this.$emit(ACTION_CARD_EVENT.CANCEL_DATA);
  }

  clearData() {
    this.billType = "";
    this.orderState = "";
    this.diagnosticPrimaryCode = "";
    this.orderCancelValue = "";
    this.nroMedicalOrder = "";
    this.model = {};
    this.updateKey = 1 - this.updateKey;
    this.newAction = {} as ActionParameters;
    this.dialogAccept = false;
    this.showDialog = false;
  }
}
